import { SelectNew, Text } from '@lune-fe/lune-ui-lib'
import type { SxProps } from '@mui/material'
import { FC, ReactElement, ReactNode } from 'react'
import { FieldRenderProps } from 'react-final-form'

import ConditionalTooltip from 'components/ConditionalTooltip'
import NotAdminTooltip from 'components/NotAdminTooltip'

type FormSelectProps<T = string> = FieldRenderProps<T> & {
    disabled?: boolean
    error?: boolean | string
    placeholder?: string
    tooltip?: FC<{ children: ReactElement }>
    sx?: SxProps
    items: {
        value: T
        label: string
        icon?: ReactNode
    }[]
}

export const FormSelectNew = <T,>({
    disabled,
    input: { onChange, value, name },
    error,
    meta,
    placeholder,
    tooltip,
    sx,
    items,
}: FormSelectProps<T>) => {
    const hasError = error || (meta.touched && meta.error)
    const errorMessage = hasError
        ? typeof error === 'string'
            ? error
            : typeof meta.error === 'string'
              ? meta.error
              : undefined
        : undefined

    return (
        <>
            <ConditionalTooltip show={!!disabled} tooltip={tooltip || NotAdminTooltip}>
                <SelectNew<T>
                    data-testid={`select-${name}`}
                    value={value}
                    items={items}
                    onChange={onChange}
                    disabled={disabled}
                    error={errorMessage}
                    placeholder={placeholder}
                    wide
                    sx={sx}
                />
            </ConditionalTooltip>
            {errorMessage && (
                <Text variant="body3" sx={{ color: 'Error', mt: 1 }}>
                    {errorMessage}
                </Text>
            )}
        </>
    )
}
